var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",class:{'inline-block': true, [_vm.iconClass]: true},attrs:{"role":"img","fill":_vm.color,"height":_vm.sizeClass,"width":_vm.sizeClass}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }